import * as React from 'react'

interface PauseResumePresentationProps {
    handleVisibilityChange: EventListenerOrEventListenerObject
}

class PauseResumePresentation extends React.Component<PauseResumePresentationProps> {

    // lets use manufacturer prefixes for compatibility
    visibilityChange: string = null

    constructor(props: PauseResumePresentationProps) {
        super(props)

        // set manufacturer prefix
        this.visibilityChange = 
            typeof (document as any).hidden !== 'undefined' ? 'visibilitychange' :
                typeof (document as any).msHidden !== 'undefined' ? 'msvisibilitychange' :
                    typeof (document as any).webkitHidden !== 'undefined' ? 'webkitvisibilitychange' :
                        null

    }

    // lets add the listener on componentDidMount
    componentDidMount() {
        document.addEventListener(this.visibilityChange, this.props.handleVisibilityChange, false)
    }

    // lets remove the listener on componentWillUnmount
    componentWillUnmount()	{
        document.removeEventListener(this.visibilityChange, this.props.handleVisibilityChange)
    }

    // we dont want to render anything here
    render(): any {
        return (null)
    }

}

export default PauseResumePresentation
